// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module__button___36sWC","loader":"styles-module__loader___3bz-X","disabled":"styles-module__disabled___3j6oJ","icon":"styles-module__icon___N4vwA"};